import { AddPatientSchema } from "../lib/validation/add-patient";
import { axiosInstance } from "./axiosInstance";


export async function addPatient(data: AddPatientSchema & { mobile: string }) {
  // console.log("axoisinstance", axiosInstance);
  // const token = getCookie("authToken");
  //console.log("Token in addPatient:", token);
  try {   
    const res = await axiosInstance.post(
      "doctor-profile/patient-profile/add-patient",
      data,
    );
    return res.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export const fetchHealthRecordsByBookingId = async (bookingId: number) => {
  try {
    const response = await axiosInstance.get(
      `${process.env.REACT_APP_API_URL}/doctor-profile/appointment-details/health-records/${bookingId}`,
    );
    return response.data;
  } catch (error: any) {
    // throw new Error("Failed to fetch health records. Please try again.");
  }
};

export const rescheduleAppointment = async (payload: {
  bookingId: number;
  appointmentDate: string;
  startTime: string;
  endTime: string;
}) => {
  try {
    const response = await axiosInstance.put(
      `${process.env.REACT_APP_API_URL}/doctor-profile/appointment-details/reschedule`,
      payload,
      {
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || "An unexpected error occurred while rescheduling.");
  }
};

export const cancelAppointment = async (bookingId: number) => {
  try {
    const response = await axiosInstance.delete(
      `${process.env.REACT_APP_API_URL}/doctor-profile/appointment-details/booking-id/${bookingId}`,
      {
        headers: {
          accept: "*/*",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || "An unexpected error occurred while canceling.");
  }
};